import type { Branding } from "@/src/branding/branding-context.ts";

export const createAigroBranding = (apiUrl?: string): Branding => ({
    cssVariables: {
        "--primary-color": "#1E4B25",
        "--light-primary-color": "#24A539",
        "--secondary-color": "#D65B18",
    },
    envVariables: {
        VITE_IOT_ADMIN_API_SERVER_URL:
            apiUrl ?? "https://ror1.staging.nazaries.cloud",
        VITE_IOT_CONTACT_URL: "https://www.aigro.es/contacto",
        VITE_IOT_BACKGROUND_IMG: "login-background.png",
        VITE_IOT_LOGO_IMG: "branding/aigro/logo.png",
        VITE_IOT_NEGATIVE_LOGO_IMG: "branding/aigro/logo-negative.png",
        VITE_IOT_LARGE_LOGO_IMG: "branding/aigro/logo-large.png",
        VITE_IOT_COOKIES_URL: "https://www.aigro.es/politica-cookies",
        VITE_IOT_LEGAL_URL: "https://www.aigro.es/aviso-legal",
        VITE_IOT_PRIVACY_URL: "https://www.aigro.es/politica-privacidad",
        VITE_IOT_ABOUT_URL: "https://www.aigro.es/nosotros",
        VITE_IOT_APP_TITLE: "Aigro",
        VITE_IOT_FAVICON: "branding/aigro/favicon.png",
    },
});
